import { useNavigate, useLocation } from 'react-router-dom'
import { useWorkspace } from '../../../../../contexts/WorkspaceContext.tsx'
import { useAppDispatch } from '../../../../../store/hooks.ts'
import { setMobileSidebarOpen } from '../../../../../store/ui/uiSlice.ts'
import TeamIcon from '../../../../../assets/icons/icon-team.svg?react'
import SidebarUiButton from '../SidebarUiButton/SidebarUiButton.tsx'
import Tooltip from '@/components/ui/Tooltip/Tooltip'

const SidebarTeamButton = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { workspace } = useWorkspace()

    const isActive = workspace && location.pathname === `/${workspace.workspaceUrlId}/team`

    const handleClick = () => {
        if (workspace) {
            navigate(`/${workspace.workspaceUrlId}/team`)
            dispatch(setMobileSidebarOpen(false))
        }
    }

    return (
        <Tooltip title="Team">
            <SidebarUiButton icon={<TeamIcon />} title="Team" isActive={!!isActive} onClick={handleClick} />
        </Tooltip>
    )
}

export default SidebarTeamButton
